import ws from '@api/webservice'
import config from '@app/config'
import { fetchPages } from '@api/utils'

const api = {
  create: (localisationId: string, body: PlanCreate) =>
    ws<Plan>(config.ws.plan.create.replace('{localisationId}', localisationId), 'POST', body),
  update: (localisationId: string, body: PlanUpdate) =>
    ws<Plan>(config.ws.plan.update.replace('{localisationId}', localisationId), 'PATCH', body),
  all: (siteId: string) => fetchPages<Plan>('plans', config.ws.plan.all.replace('{siteId}', siteId), 'GET'),
  get: (localisationId: string) => ws<Plan>(config.ws.plan.get.replace('{localisationId}', localisationId), 'GET'),
}

export default api
